export const hrTelecallerColumns = [
    {
        headerName: "Name",
        field: "name",
        width: 160,
    },
    {
        headerName: "Contact No",
        field: "mobile",
        width: 160,
    },
    {
        headerName: "Review",
        field: "review",
        width: 160
    },
    {
        field: "serviceName",
        headerName: "Gym Service",
        width: 160,
    },
    {
        field: "category",
        headerName: "Gym Category",
        width: 160,
    },
    {
        field: "branchName",
        headerName: "Branch Name",
        width: 130,
    },
    {
        field: "branchLocation",
        headerName: "Branch Loc",
        width: 130,
    },
];